// extracted by mini-css-extract-plugin
export default {"description":"checkout-delivery-charge_description__NPoRx","link":"checkout-delivery-charge_link__0QgLM"};